var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_7196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.83325C4.31992 1.83325 1.33325 4.81992 1.33325 8.49992C1.33325 12.1799 4.31992 15.1666 7.99992 15.1666C11.6799 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.6799 1.83325 7.99992 1.83325ZM8.03992 13.1666V11.8266C8.02659 11.8266 8.01325 11.8266 7.99992 11.8266C7.14659 11.8266 6.29325 11.4999 5.63992 10.8533C4.49992 9.71325 4.35992 7.95325 5.21325 6.65992L5.94659 7.39325C5.47325 8.27992 5.59325 9.39992 6.33992 10.1466C6.80659 10.6133 7.41992 10.8333 8.03325 10.8199V9.39325L9.91992 11.2799L8.03992 13.1666ZM10.7799 10.3399L10.0466 9.60659C10.5199 8.71992 10.3999 7.59992 9.65325 6.85325C9.19325 6.39325 8.59992 6.16659 7.99992 6.16659C7.98659 6.16659 7.97325 6.16659 7.95992 6.16659V7.59992L6.07325 5.71992L7.95992 3.83325V5.17992C8.82659 5.16659 9.69992 5.47992 10.3599 6.14659C11.4933 7.27992 11.6333 9.04659 10.7799 10.3399Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_7196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateStatus);
export default __webpack_public_path__ + "static/media/UpdateStatus.317bdadcb29a8083985895559d9daffb.svg";
export { ForwardRef as ReactComponent };